export const Height = {
	full: 'h-full',
	0: 'h-0',
	2: 'h-2',
	5: 'h-5',
	7: 'h-7',
	52: 'h-52',
	'200%': 'h-[200%]',
} as const;
